// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1DgJM","paramInput":"JobSimulator_paramInput__35LY3","input":"JobSimulator_input__19c4o"};